import { useTranslation } from "react-i18next";
import { CardCarousel } from "@/components/CardCarousel";

const VALUE_BACKGROUNDS = [
  "/valeurs/bg_curiosite.jpg",
  "/valeurs/bg_humilite.jpg",
  "/valeurs/bg_bienveillance.jpg",
  "/valeurs/bg_audace.jpg",
  "/valeurs/bg_perseverance.jpg",
];

export function ValeursCocoon() {
  const { t } = useTranslation();
  const values = t("landing.values", { returnObjects: true });
  const items = Array.isArray(values?.items) ? values.items : [];

  return (
    <section className="max-w-6xl mx-auto px-6 py-14 sm:py-24" data-testid="valeurs-section">
      <div className="text-center mb-14">
        <p className="text-primary/80 tracking-[0.25em] uppercase text-xs mb-5">{values.eyebrow}</p>
        <h2 className="font-display text-gradient-orange text-3xl sm:text-4xl italic mx-auto max-w-2xl leading-tight">
          {values.title}
        </h2>
        <p className="mt-6 text-foreground/60 leading-relaxed max-w-2xl mx-auto italic">{values.subtitle}</p>
      </div>

      <div className="max-w-4xl mx-auto">
        <CardCarousel
          testId="valeurs-carousel"
          slides={items.map((v, i) => {
            const bg = VALUE_BACKGROUNDS[i % VALUE_BACKGROUNDS.length];
            return (
              <article className="relative overflow-hidden glass frame-pulse rounded-3xl p-8 md:p-12 min-h-[500px] sm:min-h-[440px] flex flex-col justify-center" data-testid={`valeur-${i}`}>
                <div className="absolute inset-0" aria-hidden="true">
                  <img
                    src={bg}
                    alt=""
                    data-testid={`valeur-bg-${i}`}
                    className="w-full h-full object-cover opacity-70"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-background/20" />
                  <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/35 to-transparent" />
                </div>
                <div className="relative z-10">
                  <p className="text-[11px] uppercase tracking-[0.22em] text-primary/70 mb-2">{v.sub}</p>
                  <h3 className="font-display text-2xl md:text-3xl mb-4 leading-tight">{v.title}</h3>
                  <p className="text-foreground/70 leading-[1.9] text-base md:text-lg max-w-xl">{v.text}</p>
                </div>
              </article>
            );
          })}
        />
      </div>
    </section>
  );
}
